import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState, useContext } from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import SectionTitle from "../../components/section-title/SectionTitle";
import ProductGrid from "./ProductGrid";
import { AuthContext } from "../../common/Auth"
import axios from "axios"
import { X_TENANT_ID, TAGS_URL } from '../../common/ActionUrl'
import EditTaggedProductIcon from "./editTaggedProduct/EditTaggedProductIcon"
import { USERTYPES } from "../../constant/userType"
import { Link } from "react-router-dom";
import { useThemeSettings } from "../../layouts/state/useThemeSettings";

const TabProduct = ({
  spaceTopClass,
  spaceBottomClass,
  bgColorClass,
  category
}) => {
  const [featuredproductSettings, setFeaturedproductSettings] = useState({})
  const [tagsData, setTagsData] = useState([])
  const [productSettings, setProductSettings] = useState(null);
  const { themeSettingsData, userType, settingData } = useContext(AuthContext)
  const [tabEnabled, setTabEnabled] = useState(false);
  const [defaultTab, setDefaultTab] = useState(0);
  const {themedefaultTextColor, themedefaulthoverColor} = useThemeSettings({ settingData })
  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      let catIds = [];
      themeSettingsData.map((i) => {
        if (i.settingsName === "productpageSettings") {
          if (i.values && i.values[0]) {
            setProductSettings(i.values[0])
          }
        }
		if (i.settingsName === "taggedProducts") {
			setFeaturedproductSettings(i.values[0]);
			if (i.values[0]?.tabList?.length > 0) {
				i.values[0].tabList.map((tab, index) => {
					if (tab.tabProductCat != "") {
						catIds.push(tab.tabProductCat)
					}
					if(tab.tabEnabled && !tabEnabled){
						setTabEnabled(true)
						setDefaultTab(index)
					}
				})
			}
		}
      })
      let componentMounted = true;
      if (catIds.length > 0) {
        const fetchData = async (data) => {
          const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
            data: data
          }
          await axios.post(TAGS_URL, data, requestOptions)
            .then((res) => {
              let data = {}
              res.data.map(tag => {
                data[tag._id] = tag
              })
              if (componentMounted) {
                setTagsData(data)
              }
            }).catch(err => {
              console.log('err', err);
            });
        }
        fetchData({ tagsIds: catIds });
      }
      return () => {
        componentMounted = false;
      }
    }
  }, [themeSettingsData])
  let titleStyle = {};
  let subTitleStyle = {};

  if (featuredproductSettings) {
    titleStyle = {
      fontSize: featuredproductSettings.sectionTitleFontSize > 0 ? featuredproductSettings.sectionTitleFontSize + "px" : "",
      fontFamily: featuredproductSettings.sectionTitleFont,
      color: featuredproductSettings.sectionTitleColor ? featuredproductSettings.sectionTitleColor : ""
    }
    subTitleStyle = {
      fontSize: featuredproductSettings.sectionSubTitleFontSize > 0 ? featuredproductSettings.sectionSubTitleFontSize + "px" : "",
      fontFamily: featuredproductSettings.sectionSubTitleFont,
      color: featuredproductSettings.sectionSubTitleColor ? featuredproductSettings.sectionSubTitleColor : ""
    }
  }

  let pt = featuredproductSettings.paddingTop ? featuredproductSettings.paddingTop : "pt-50";
  let pb = featuredproductSettings.paddingBottom ? featuredproductSettings.paddingBottom : "pb-50";
  let mb = featuredproductSettings.marginBottom ? featuredproductSettings.marginBottom : "mt-50";
  let mt = featuredproductSettings.marginTop ? featuredproductSettings.marginTop : "mb-50";
  let mr = featuredproductSettings.marginRight ? featuredproductSettings.marginRight : "mr-0";
  let ml = featuredproductSettings.marginLeft ? featuredproductSettings.marginLeft : "ml-0";
  let pl = featuredproductSettings.paddingLeft ? featuredproductSettings.paddingLeft : "pl-0";
  let pr = featuredproductSettings.paddingRight ? featuredproductSettings.paddingRight : "pr-0";
  let fullSection = featuredproductSettings.fullSection ? "container-fluid" : "container";
  let bgImage = featuredproductSettings?.bgImage ? featuredproductSettings?.bgImage : "";
  let bgColor = featuredproductSettings?.bgColor ? featuredproductSettings?.bgColor : "";

  let tabAlign = featuredproductSettings?.tabAlign ? featuredproductSettings?.tabAlign : "center";

  return (
    <div
      className={`antera-tag-product-section-container product-area section-bgImage ${pt} ${pb} ${pl} ${pr} ${mb} ${mt} ${mr} ${ml} ${bgColorClass ? bgColorClass : ""}`}
      style={(bgImage?.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`antera-tag-product-content-container ${fullSection}`}>
        <div className="edit-img">
          <EditTaggedProductIcon />
        </div>
        {userType && userType !== USERTYPES.USER && (!tabEnabled) &&
          <SectionTitle
            titleText={"DAILY DEALS!"}
            titlepositionClass="text-center" />}
        {(tabEnabled) && <>
          {(featuredproductSettings && (featuredproductSettings.sectionTitleEnabled || featuredproductSettings.sectionSubTitleEnabled)) &&
            <SectionTitle
              titleText={featuredproductSettings.sectionTitleEnabled ? (featuredproductSettings && featuredproductSettings.sectionTitle != "") ? featuredproductSettings.sectionTitle : "DAILY DEALS!" : null}
              subTitleText={featuredproductSettings.sectionSubTitleEnabled ? (featuredproductSettings && featuredproductSettings.sectionSubTitle != "") ? featuredproductSettings.sectionSubTitle : "" : null}
              />
			  }
				  <Tab.Container defaultActiveKey={defaultTab}>
            <style >
              {`.tag-heading-text{
                  color: ${themedefaultTextColor};
                }
                .tag-heading-text:hover,
                .tag-heading-link.active .tag-heading-text{
                  color: ${themedefaulthoverColor} !important;
                }`
              }
            </style>
					  <Nav
						  variant=""
						  className={`product-tab-list pt-30 pb-55 ${tabAlign}`}
					  >
						  {
							  (featuredproductSettings && featuredproductSettings.tabList && featuredproductSettings.tabList.length > 0) &&
							  featuredproductSettings.tabList.map((tab, index) => {
								  let tabStyle = {
									  fontSize: tab.tabFontSize > 0 ? tab.tabFontSize + "px" : "",
									  fontFamily: tab.tabFont,
									  color: tab.tabColor ? tab.tabColor : ""
								  }
								  return (tab.tabEnabled) && <Nav.Item>
									  <Nav.Link eventKey={index} className="tag-heading-link">
										  <h4 className="antera-tag-heading-text tag-heading-text" style={tabStyle}>{(tab && tagsData[tab.tabProductCat]) ? tagsData[tab.tabProductCat].tagName : "Featured Products"}</h4>
									  </Nav.Link>
								  </Nav.Item>
							  })
						  }
					  </Nav>
					  <Tab.Content>
						  {(featuredproductSettings && featuredproductSettings.tabList && featuredproductSettings.tabList.length > 0) &&
							  featuredproductSettings.tabList.map((tab, index) => {
								  return (tab.tabEnabled) &&
									  <Tab.Pane eventKey={index}>
										  <div className="row">
											  <ProductGrid
												  tabProductCat={tab.tabProductCat}
												  category={category}
												  limit={(productSettings && productSettings['numberoffeaturedProducts']) ? productSettings['numberoffeaturedProducts'] : "8"}
												  spaceBottomClass="mb-25"
												  isTab={true}
                          tagName = {tagsData[tab.tabProductCat]}
											  />
										  </div>
									  </Tab.Pane>
							  })}

					  </Tab.Content>
				  </Tab.Container>
          <div className="view-more text-center mt-20 toggle-btn6 col-12">
            <Link
              className="loadMore6"
              to={process.env.PUBLIC_URL + "/products"}
            >
              VIEW ALL PRODUCTS
            </Link>
          </div>
        </>
        }
      </div>
    </div>
  );
};

TabProduct.propTypes = {
  bgColorClass: PropTypes.string,
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TabProduct;
